import React, { useState, useRef, useEffect } from "react";
import "../newFacebookCampaign/CreateCampaignTemplate.css";
import "../newFacebookCampaign/nameCampaign.css";
import "./GoogleCreateTemplate.css";
import {
  CampaignType,
  Goals,
  objectives,
} from "../newFacebookCampaign/GoogleAutomationConstants";

const NameCampaign = () => {
  return (
    <div>
      <div className="create-form-item">
        <div style={{ fontWeight: "bold" }}>Name Your Campaign</div>
        <div className="common-input-container" data-label="Campaign Name">
          <input
            type="text"
            style={{ width: "350px" }}
            placeholder="eg Adglobal360 Festive"
          />
        </div>
      </div>
    </div>
  );
};
const AnimatedBucket = () => {
  const [showBoxes, setShowBoxes] = useState([false, false, false]);

  const handleMouseEnter = () => {
    setShowBoxes([true, false, false]);
    setTimeout(() => setShowBoxes([true, false, true]), 300);
    setTimeout(() => setShowBoxes([true, true, true]), 600);
  };

  const handleMouseLeave = () => {
    setShowBoxes([false, false, false]);
  };

  return (
    <div
      className="bucket-container"
      style={{ position: "relative" }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        className="fill-box-container"
        style={{ display: "flex", alignItems: "end" }}
      >
        <div
          className={`fill-box small-box box-3 ${showBoxes[2] ? "punch" : ""}`}
        ></div>

        <div
          className={`fill-box small-box box-2 ${showBoxes[1] ? "punch" : ""}`}
        ></div>
        <div
          className={`fill-box small-box box-1 ${showBoxes[0] ? "punch" : ""}`}
        ></div>
      </div>
      <div className="bucket-icon">
        <svg
          width="30"
          height="30"
          viewBox="0 0 50 42"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.691895 2.20661C0.691895 3.06542 1.40443 3.79855 2.24223 3.79855H9.32211L12.6737 26.7974C13.1134 29.772 14.6844 31.6363 17.7215 31.6363H42.1661C42.9829 31.6363 43.6946 30.9658 43.6946 30.0654C43.6946 29.1646 42.9829 28.4941 42.1661 28.4941H18.0776C16.8837 28.4941 16.1506 27.6563 15.9623 26.3788L15.6264 24.1794H42.2077C45.2659 24.1794 46.8364 22.294 47.2765 19.2989L48.9521 8.21833C48.9942 7.94593 49.0362 7.61089 49.0362 7.42214C49.0362 6.41704 48.2816 5.72553 47.1298 5.72553H12.9453L12.5266 3.06542C12.3172 1.45246 11.7304 0.635681 9.59408 0.635681H2.24223C1.40443 0.635681 0.691895 1.36881 0.691895 2.20661ZM15.9623 38.4228C15.9623 40.3288 17.4702 41.816 19.3765 41.816C21.2615 41.816 22.7693 40.3288 22.7693 38.4228C22.7693 36.5374 21.2615 35.0296 19.3765 35.0296C17.4702 35.0296 15.9623 36.5374 15.9623 38.4228ZM35.5465 38.4228C35.5465 40.3288 37.0754 41.816 38.9608 41.816C40.8667 41.816 42.375 40.3288 42.375 38.4228C42.375 36.5374 40.8667 35.0296 38.9608 35.0296C37.0754 35.0296 35.5465 36.5374 35.5465 38.4228Z"
            fill="#2F53EB"
          />
        </svg>
      </div>
    </div>
  );
};
const ChooseYourObjectiveStep = () => {
  const [selectedObjective, setSelectedObjective] = useState(null);

  return (
    <div className="objective-campaign-container mb-20">
      <p className="f-16 f-bold">Choose your objective</p>
      <p className="f-12">
        Select an objective to tailor your experience to the goals and settings
        that will work best for your campaign.
      </p>
      <div className="objectives-grid">
        {objectives.map((obj, index) => (
          <div
            key={index}
            className={`objective-card overflow-hidden ${
              selectedObjective === index ? "selected" : ""
            }`}
            onClick={() => setSelectedObjective(index)}
          >
            <span className="icon">
              <AnimatedBucket />
            </span>
            <div className="o-card-body">
              <p className="f-12 o-card-title">{obj.title}</p>
              <p className="f-10 ">{obj.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const ChooseYourGoalStep = () => {
  const [selectedObjective, setSelectedObjective] = useState(null);
  const [visibleTooltip, setVisibleTooltip] = useState(null);
  const tooltipRef = useRef(null);

  const handleMouseEnter = (tooltipId) => {
    setVisibleTooltip(tooltipId);
  };

  const handleClickOutside = (event) => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
      setVisibleTooltip(null);
    }
  };

  useEffect(() => {
    if (visibleTooltip !== null) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [visibleTooltip]);

  useEffect(() => {
    if (visibleTooltip !== null && tooltipRef.current) {
      const tooltip = tooltipRef.current;
      const rect = tooltip.getBoundingClientRect();
      const screenWidth = window.innerWidth;

      if (rect.right > screenWidth) {
        tooltip.style.left = "auto";
        tooltip.style.right = "0";
      } else {
        tooltip.style.left = "100%";
        tooltip.style.right = "auto";
      }
    }
  }, [visibleTooltip]);

  return (
    <div className="objective-campaign-container mb-20">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "50px",
        }}
      >
        <div>
          <p className="f-16 f-bold">
            Use these conversion goals to improve Sales
          </p>
          <p className="f-12">
            Select an objective to tailor your experience to the goals and
            settings that will work best for your campaign.
          </p>
        </div>
        <button
          className="template-button f-12"
          style={{ whiteSpace: "nowrap" }}
        >
          + Add New Goal
        </button>
      </div>
      <div className="objectives-grid">
        {Goals.map((obj, index) => (
          <div
            key={index}
            className={`goal-card ${
              selectedObjective === index ? "selected" : ""
            }`}
            style={{
              alignItems: "unset",
              justifyContent: "space-between",
              cursor: "auto",
            }}
          >
            <div className="o-card-body">
              <p className="f-16 o-card-title">{obj.title}</p>
              <div>
                <p className="f-10 f-bold">{obj.subTopic1}</p>
                <p className="f-8 f-gray">{obj.subDesc1}</p>
                <p className="f-10 f-bold">{obj.subTopic2}</p>
                <p className="f-8 f-gray">{obj.subDesc2}</p>

                {/* Tooltip Logic */}
                <div className="tooltip-container">
                  <p
                    className="f-10 link"
                    onClick={() => handleMouseEnter(index)}
                  >
                    Actions
                  </p>
                  {visibleTooltip === index && (
                    <div className="tooltip-box" ref={tooltipRef}>
                      <div className="tooltip-header">
                        1 inactive or unverified conversion action from YouTube
                        hosted for the Engagements goal
                      </div>
                      <div className="tooltip-content f-10">
                        <strong>1 Inactive Conversion Action</strong>
                        <p className="f-10">YouTube channel subscriptions</p>
                        <div className="status f-10">
                          <span className="dot f-10"></span> No recent
                          conversions, Value: ₹1.00
                        </div>
                        <p className="f-10">
                          You can <a href="#">edit this goal</a> on your
                          Conversions page
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <span className="icon">
              <svg
                className="w-6 h-6 text-gray-800 dark:text-white"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeWidth="2"
                  d="M12 6h.01M12 12h.01M12 18h.01"
                />
              </svg>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
const ChooseCampaignType = () => {
  const [selectedObjective, setSelectedObjective] = useState(null);

  return (
    <div className="objective-campaign-container mb-20">
      <p className="f-16 f-bold">Choose your objective</p>
      <p className="f-12">
        Select an objective to tailor your experience to the goals and settings
        that will work best for your campaign.
      </p>
      <div className="objectives-grid">
        {CampaignType.map((obj, index) => (
          <div
            key={index}
            className={`objective-card ${
              selectedObjective === index ? "selected" : ""
            }`}
            onClick={() => setSelectedObjective(index)}
          >
            <span className="icon">
              <AnimatedBucket />
            </span>
            <div className="o-card-body">
              <p className="f-12 o-card-title">{obj.title}</p>
              <p className="f-10 ">{obj.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
const ReachYourGoal = () => {
  const [selected, setSelected] = useState("websiteVisit");

  return (
    <div className="objective-campaign-container mb-20">
      <p className="f-16 f-bold">
        Select the ways you'd like to reach your goal
      </p>
      <p className="f-12 mb-20">
        Select an objective to tailor your experience to the goals and settings
        that will work best for your campaign.
      </p>
      <div className="radio-container objectives-grid">
        <label
          className={`radio-label ${
            selected === "advantage" ? "selected" : ""
          }`}
        >
          <input
            type="radio"
            name="placement"
            value="websiteVisit"
            checked={selected === "websiteVisit"}
            onChange={() => setSelected("websiteVisit")}
          />
          <div>
            <p className="f-14 f-bold">
              <span>Website Visit</span>{" "}
            </p>
          </div>
        </label>

        <label
          className={`radio-label ${selected === "manual" ? "selected" : ""}`}
        >
          <input
            type="radio"
            name="placement"
            value="phoneCall"
            checked={selected === "phoneCall"}
            onChange={() => setSelected("phoneCall")}
          />
          <div>
            <p className="f-14 f-bold">Phone Call</p>
          </div>
        </label>
        <label
          className={`radio-label ${selected === "manual" ? "selected" : ""}`}
        >
          <input
            type="radio"
            name="placement"
            value="storeVisit"
            checked={selected === "storeVisit"}
            onChange={() => setSelected("storeVisit")}
          />
          <div>
            <p className="f-14 f-bold">Store Visit</p>
          </div>
        </label>
      </div>
    </div>
  );
};

const CreateGoogleCampaignTemplate = ({ currentStep, nextStep }) => {
  return (
    <div>
      {currentStep === 1 ? (
        <NameCampaign />
      ) : currentStep === 2 ? (
        <ChooseYourObjectiveStep />
      ) : currentStep === 3 ? (
        <ChooseYourGoalStep />
      ) : currentStep === 4 ? (
        <ChooseCampaignType />
      ) : currentStep === 5 ? (
        <ReachYourGoal />
      ) : (
        <></>
      )}
      <div className="create-form-item">
        <div className="actions">
          <button
            className="back-button"
            onClick={() => nextStep(currentStep - 1)}
          >
            <svg
              className="w-6 h-6 text-white dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 12h14M5 12l4-4m-4 4 4 4"
              />
            </svg>
            Previous
          </button>
          <button
            className="continue-button"
            disabled={currentStep === 5}
            onClick={() => nextStep(currentStep + 1)}
          >
            Continue{" "}
            <svg
              className="w-6 h-6 text-white dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 12H5m14 0-4 4m4-4-4-4"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateGoogleCampaignTemplate;
